import type { Root, RootContent } from "mdast";

// Collapses runs of consecutive markdown horizontal rules (`---`) into a single rule.
//
// Why: mistral-medium-3.5 occasionally emits two or three `---` lines in a row to convey a
// "bigger" section break. CommonMark / remark-gfm renders each one as a separate `<hr>`, so the
// user sees a stack of thin lines instead of one separator. The system prompt nudges the model
// away from this but can't guarantee it (sampling). This plugin removes the surplus rules in the
// parsed AST so the rendered DOM has at most one `<hr>` between any two siblings.
export function remarkCollapseHorizontalRules() {
    return (tree: Root) => {
        collapseInChildren(tree as { children: RootContent[] });
    };
}

function collapseInChildren(node: { children: RootContent[] }) {
    const children = node.children;
    for (let i = children.length - 1; i > 0; i--) {
        if (children[i].type === "thematicBreak" && children[i - 1].type === "thematicBreak") {
            children.splice(i, 1);
        }
    }
    for (const child of children) {
        if ("children" in child && Array.isArray((child as { children?: unknown }).children)) {
            collapseInChildren(child as unknown as { children: RootContent[] });
        }
    }
}
